import React from 'react'
import { PasswordlessAuthentication } from '@ztechapps/webui.auth'
import { appSettings } from '../../../config/app-settings'

export const PasswordlessAuthLayout = () => {
  const recaptchaSiteKey = appSettings?.Google?.recaptchaSiteKey

  return <PasswordlessAuthentication recaptchaSiteKey={recaptchaSiteKey} url="/api/auth/passwordless" />
}
